module.exports = __webpack_public_path__ + "img/header_dsk@2x.4e7774e.webp";